import InitMaps from './modules/_maps'

window.addEventListener('load', () => {
  InitMaps()
})
